import { render, staticRenderFns } from "./FeedItemTextMsg.vue?vue&type=template&id=24dd28d9&scoped=true&"
import script from "./FeedItemTextMsg.vue?vue&type=script&lang=js&"
export * from "./FeedItemTextMsg.vue?vue&type=script&lang=js&"
import style0 from "./FeedItemTextMsg.vue?vue&type=style&index=0&id=24dd28d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../tasks/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dd28d9",
  null
  
)

export default component.exports